/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  returnSwatchObj(state, getters, rootState) {
    return ({ swatchId }) => {
      const numSwatchId = Number(swatchId);
      const { availableSwatches } = rootState.utils;
      let swatchFind = availableSwatches.find(swatch => {
        return Number(swatch.id) === numSwatchId;
      });
      return swatchFind;
    };
  },
  returnSwatchGroupName() {
    return ({ swatch }) => {
      const groupName = swatch["cq:tags"] ? swatch["cq:tags"][0].split("/") : "";
      return groupName[groupName.length - 2];
    };
  },
  returnSwatchSubgroupName() {
    return ({ swatch }) => {
      const subgroupName = swatch?.["cq:tags"] ? swatch?.["cq:tags"]?.[0].split("/") : "";
      return subgroupName[subgroupName.length - 1];
    };
  },
  getExlusiveSwatches(state, getters, rootState) {
    let exclusiveSwatches = [];

    rootState.utils.availableSwatches.forEach(swatch => {
      if (swatch.exclusive) {
          exclusiveSwatches.push(Number(swatch.id));
      }
    });
    return exclusiveSwatches;
  },
  isUGCFromSwatch(state, getters, rootState) {
    return ({ swatchId }) => {
      const swatch =rootState.utils.availableSwatches.find(swatch => {
        return Number(swatch.id) === swatchId;
      });
      return swatch && swatch.ugc;
    };
  },
  getPaletteDataBySwatch(state, getters, rootState) {
    return (swatchId, dataAttribute = 'group') => {
      const numSwatchId = Number(swatchId);
      const activeComponent = rootState.legacyNavigation.activeComponent;
      const swatchesbyComponent = state.tabsSwatches[activeComponent];
      for (let group in swatchesbyComponent) {
        if(swatchesbyComponent[group].palette_tab){
          for (let subgroup in swatchesbyComponent[group].subgroups) {
              if(swatchesbyComponent[group].subgroups[subgroup].swatches){
                const swatchFind = swatchesbyComponent[group].subgroups[subgroup].swatches.find(swatch => Number(swatch.id) === numSwatchId);
                const paletteId = swatchesbyComponent[group].subgroups[subgroup].palette_id;

                if(swatchFind && dataAttribute === 'group'){
                  return group;
                } else if (swatchFind && dataAttribute === 'id' && paletteId) {
                  return paletteId;
                }
              }
          }//subgroups
        }
      } // group
      return null;
    };
  },
  isUGCFromPrecreated(state, getters, rootState) {
    return ({ swatchId, componentName }) => {
      const component = rootState.recipe.recipe_v2.components[componentName];
      if(component && component.ugc) {
        return rootState.recipe.defaultRecipe?.components?.[componentName]?.swatch_id === swatchId;
      } else {
        return false;
      }
    };
  },
  /** Return restricted components for active component */
  getRestrictedComponents(state, getters, rootState) {
    return ({ object, activeComponent }) => {
      if(!object) return [];

      if(object.restricted_components && object.restricted_components.includes(activeComponent)) {
        return object.restricted_components.filter(component => component !== activeComponent);
      }
      return [];
    };
  },
  lockedPalettes(state, getters, rootState) {
    return state.palettes
      .filter(palette => !!palette.palette_lock)
      .map(({ palette_id, tab_id }) => ({ id: palette_id, tab: tab_id }));
  },
  uniqueSwatches(state, getters, rootState) {
    return rootState.utils.availableSwatches
      .filter(swatch => state.swatchesInPalettes.includes(parseInt(swatch.id)) && swatch.unique_swatch);
  },
  returnSwatchbyMaterialType(state, getters, rootState) {
    return ({ materialType }) => {
      const { availableSwatches } = rootState.utils;
      return availableSwatches.find(swatch => swatch.material_type === materialType);
    };
  },
};

export default getters;
